var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "main",
    {
      staticClass: "app-horizontal-layout",
      attrs: {
        "aria-live": "assertive",
        "aria-busy": _vm.session_ready ? "false" : "true"
      }
    },
    [!_vm.session_ready ? [_c("preloader")] : [_c("Login")]],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }